"use client";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";
import Backend, { type HttpBackendOptions } from "i18next-http-backend";

import i18next from "i18next";
import { Log } from "../log/Log";
import { isServer } from "../nextjs/env/env";
;
export { useTranslation } from 'react-i18next';
let fileDateVersion:string = ''// = getConfig().publicRuntimeConfig?.version
export const i18nLogger = new Log(false, `i18n`);
const windowHref = (()=>{
  if(typeof window === 'undefined')return ''
  const u = new URL(window.location.href || window.parent?.location.href);
  // 同域文本iframe里的页面会获取不到href，所以判断一下直接用父级的就行.
  return u.origin == null || u.origin == 'null' ? '' : u.origin
})()
const backendOptions = {
  loadPath: function (lngs: string[], namespaces: string[]) {
    const log = i18nLogger.sub(false, `i18n loadpath`);
    log.pause = true;
    const lng = lngs[0]
    let p = ``
    // p = `/options/_locales/${lngs[0].replace("-", "_")}/messages.json`;
    // p = `/locales/zh-CN/ns1/content.json`;
    // p = `locales/${lng}/${namespaces[0]}.json?v=${fileDateVersion}`
    const ps = namespaces[0].split('/')
    ps.splice(ps.length - 1, 0, lng)
    p = `locales/${ps.join('/')}.json?v=${fileDateVersion}`
    log.log(`lngs=`, lngs);
    log.log(`namespaces=`, namespaces);
    log.log("p=", p);
    p = `${windowHref}/${p}`
    log.log('windowHref p=', p)
    return p;

  },
  parse: function (
    data: string,
    languages?: string | string[],
    namespaces?: string | string[]
  ) {
    const log = i18nLogger.sub(false, `i18n backend parse`);
    log.pause = true;
    // log.log(`parrrse`, data, languages, namespaces);
    const l = JSON.parse(data);
    log.print(`before set i18ndata`);
    // i18nData = l as II18n;
    // log.log(`i18nData.rule.scripts.sys.rules`, i18nData.rule.scripts.sys.rules);
    log.log(`parrrse`, languages, namespaces);
    return l;
  },
};
const backend = new Backend();
backend.init(null, backendOptions);
export const i18n = i18next;
// export const resources: Resource = {
//   // 'zh-CN': {
//   //   translation: _.merge({}, zhCN),
//   // },
//   // en: {
//   //   translation: _.merge({}, en),
//   // },
// };


i18n.on("languageChanged", async function (lng) {
  const log = i18nLogger.sub(false, `onlanguageChanged`);
  log.pause = true;
  log.log(`lllllng`, lng);
  // lng = "en";
  // const p = `/options/_locales/${lng.replace("-", "_")}/messages.json`;
});




export function i18nInit(_fileDateVersion:string=''){
  fileDateVersion = _fileDateVersion
  i18n
  .use(LanguageDetector)
  .use(backend)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    load: "currentOnly",
    // load: "all",
    // supportedLngs: ['zh-CN', 'zh-TW', 'en', 'en-GB', 'ja'],
    // resources,
    fallbackLng: isServer ? "en" : "zh-CN",
    // fallbackLng: "zh-CN",
    // lng: "zh-CN",
    partialBundledLanguages:true,
    ns:[],
    
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      caches: ["localStorage"],
    },
  });
}
i18n.on("missingKey", function (lngs, namespace, key, res) {
  console.error(
    "i18n mssing key, lngs=%s, namespace=%s, key=%s, res=%s",
    lngs,
    namespace,
    key,
    res
  );
});

i18n.on("loaded", function (loaded) {
  const log = i18nLogger.sub(false, `onloaded`);
  log.pause = true;
  log.log(`onloaded arguments`, loaded);
});

i18n.on("failedLoading", function (lng, ns, msg) {
  const log = i18nLogger.sub(false, `onfailedLoading`);
  log.pause = true;
  log.log(`failedLoading arguments`, lng, ns, msg);
});

i18n.on("added", function () {
  console.log('added', arguments)
});   

export default i18n;